import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
//import logo from './logo.svg';
import Home from './Home.js';
import Projects from './Projects.js';
import Contact from './Contact.js';
import About from './About.js';
import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Route exact path="/" component={Home} />
          <Route path="/projects" component={Projects} />
          <Route path="/contact" component={Contact} />
          <Route path="/about" component={About} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js